<template>
  <section>
    <div class="user-main">
      <div class="user-cont layui-card">
        <div class="layui-card-header layui-card-header-auto">
          <div class="utab clearfix">
            <ul class="clearlist clearfix fl">
              <li :class="nowStatus==1?'active':''" @click="changeTab('1')">
                <a href="javascript:;">可用优惠券</a>
              </li>
              <li :class="nowStatus=='2'?'active':''" @click="changeTab('2')">
                <a href="javascript:;">已使用</a>
              </li>
              <li :class="nowStatus==3?'active':''" @click="changeTab('3')">
                <a href="javascript:;">已过期</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="all_coupons flex">
          <li class="couponItem" v-for="(item,index) in counplist.data" :key="index">
            <div class="couponsInfo center">
                <img src="/static/images/coupon_guoqied.png" v-if="item.status==2" alt srcset class="coupons_type" />
              <div class="price flex">
                <span class="text">￥</span>
                <span class="num">{{item.amount}}</span>
              </div>
              <div class="manjian">满{{item.cost}}元可用</div>
              <div class="time">{{item.startTime}} <br/> {{item.startTo}}</div>
            </div>
            <button type v-if="nowStatus==1" class="active primary_bor"><a href="#/">立即使用</a></button>
            <button type v-if="nowStatus==2" class="primary_bor"><a href="javascripy:;">已使用</a></button>
            <button type v-if="nowStatus==3" class="primary_bor"><a href="javascripy:;">已过期</a></button>
            <!-- <button type class=" primary_bor" v-if="nowStatus==2">立即使用</button>
            <button type class=" primary_bor" v-if="nowStatus==3">立即使用</button> -->
          </li>

        </div>
      </div>
       <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="~~counplist.per_page"
        @current-change="currentPage"
        :total="counplist.total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
export default {
  name: "Coupons",
  data() {
    return {
      nowStatus: 1,
      counplist: {},
      page: 1,
      guid: sessionStorage.guid,
      orderstatus: [{ 0: "可用优惠券" }, { 1: "已使用" }, { 2: "已过期" }]
    };
  },
  props: {},
  methods: {

    currentPage(e){
      this.page=e;
      this.getlistData()
    },

    // 改变tab
    changeTab(type) {
      this.nowStatus = type;
      this.getlistData();
    },
    
  getdate(date) {
        date = new Date(date);
        var Y = date.getFullYear() + '-';
	    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	    var D = date.getDate() + ' ';
	    var h = date.getHours()<10?'0'+date.getHours()+ ':':date.getHours()+ ':';
	    var m = date.getMinutes()<10?'0'+date.getMinutes()+ ':':date.getMinutes()+ ':';
	    var s = date.getSeconds()<10?'0'+date.getMinutes():date.getMinutes();;
	    return Y + M + D + h + m + s;

 },


    async getlistData() {
     let res = await this.$fetch("member/couponlist", {
        body: { page: this.page,type:this.nowStatus,pagesize:12}
      });
      // this.fenye();
      // console.log()
      for(let i=0;i<res.data.length;i++){
        // console.log(this.getdate(res.data[i].timefrom*1000))
        res.data[i]['startTime']=this.getdate(res.data[i].timefrom*1000)
        res.data[i]['startTo']=this.getdate(res.data[i].timeto*1000)
      }
       this.counplist=res;
       console.log(this.counplist)
    }
  },

  async mounted() {
    // this.fenye();
    await this.getlistData()
    // this.fenye();
    // console.log("counplist", this.counplist);
  }
};
</script>
<style lang='scss' scoped>
.all_coupons {
  padding: 20px;
  box-sizing: border-box;
  // height: 550px;
  align-items: flex-start;
  // overflow-y: auto;
  flex-wrap: wrap;
  .couponItem :nth-child(4n) {
    margin-right: 0;
  }
  .couponItem {
    width: 200px;
    height: 255px;
    position: relative;
    background: rgba(250, 250, 250, 1);
    margin-right: 15px;
    margin-bottom: 20px;
    .couponsInfo {
      width: 100%;
      height: 184px;
      background: url("/static/images/coupons_bg.png");
      background-size: 100% 100%;
      flex-direction: column;
      .coupons_type {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .price {
        font-weight: bold;
        align-items: flex-start;
        color: #fff;
        .text {
          font-size: 24px;
          line-height: 24px;
        }
        .num {
          font-size: 40px;
          line-height: 40px;
        }
      }
    }
    .manjian {
      font-size: 12px;
      color: #fff;
      margin: 10px 0;
    }
    .time {
      color: #418d13;
      font-size: 12px;
    }
    button {
      width: 121px;
      font-size: 14px;
      border-radius: 17px;
      height: 33px;
      position: absolute;
      bottom: 23px;
      left: 48px;
      background: rgba(179, 179, 179, 1);
      color: rgba(254, 254, 254, 1);
    }
    .active {
      border: 1px solid rgba(143, 212, 101, 1);
      color: rgba(143, 212, 101, 1);
      background: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupons.vue